import Patients from './patients';

export default Patients;
